<template>
  <div class="verification-required-actions">
    <VLoadingSpinner size="medium" v-if="processingNewVerification" />

    <VButton
        v-if="!resendRequested"
        type="outline-1"
        :fullwidth="true"
        @click="resendVerification"
        data-ec="verification_required_modal"
        data-et="resend_verification_email">
        <span>{{ $t('dashboard.verification.cta.initial') }}</span>
    </VButton>

    <VMessage
      v-if="resendRequested"
      type="info"
      :fullwidth="true">
      <template v-slot:icon>
        <EnvelopeIcon />
      </template>
      <template v-slot:text>
        <span class="email-reminder">{{ $t('dashboard.verification.cta.confirmed') }}<span>{{ company.email }}</span></span>
      </template>
    </VMessage>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import VButton from '@/components/deprecated/atoms/Button.vue';
import VMessage from '@/components/deprecated/atoms/Message.vue';
import VLoadingSpinner from '@/components/deprecated/atoms/LoadingSpinner.vue';
import { EnvelopeIcon } from '@/components/icons/fontIcons';

export default {
  name: 'VVerificationRequiredActions',
  components: {
    VButton,
    VMessage,
    VLoadingSpinner,
    EnvelopeIcon,
  },
  mounted() {
    this.$store.dispatch('company/GET');
  },
  data() {
    return {
      resendRequested: false,
      processingNewVerification: false,
    };
  },
  computed: {
    ...mapGetters({
      company: 'company/company',
    }),
  },
  methods: {
    resendVerification() {
      this.processingNewVerification = true;

      this.$store.dispatch('company/RESEND_VERIFICATION_EMAIL').then(() => {
        this.resendRequested = true;
      }).finally(() => {
        this.processingNewVerification = false;
      });
    },
  },
};

</script>

<style scoped>
.verification-required-actions {
  position: relative;
}

.verification-required-actions .a-button {
  display: block;
  float: none;
}

.email-reminder > span {
  display: block;
  margin-top: var(--spacing-xs);
  font-size: var(--font-size-small);
  font-style: italic;
  word-break: break-word;
}
</style>
